import React, { useState } from "react";
import { Row, Col, Modal, ModalBody, Button } from "reactstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useVendor } from "../Store/VendorStore";
import "../Assets/responsive.css";

const VendorPayment = ({ isOpen, toggle }) => {
  const { vendorData } = useVendor();
  const [loading] = useState(false);

  // Open payment link
  const handlePaymentLink = (link) => {
    if (link && link.trim() !== "") {
      window.open(link, "_blank");
    }
    toggle();
  };

  // Check if link is valid
  const isLinkAvailable = (link) => link && link.trim() !== "";

  // Payment Options
  const paymentOptions = [
    {
      name: "VENMO",
      link: vendorData?.Pay_Link_Venmo,
      img: "/Images/Venmo.png",
      imgStyle: { width: "27px", height: "27px" },
    },
    {
      name: "PAYPAL",
      link: vendorData?.Pay_Link_Paypal,
      img: "/Images/PayPal.png",
      imgStyle: { width: "27px", height: "27px" },
    },
    {
      name: "CASH APP",
      link: vendorData?.Pay_Link_Cashapp,
      img: "/Images/CashApp.png",
      imgStyle: { width: "27px", height: "27px" },
    },
    {
      name: "ZELLE",
      link: vendorData?.Pay_Link_Zelle,
      img: "/Images/zelle.png",
      imgStyle: { width: "19px", height: "27px" },
    },
  ];

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
      {/* ❌ Close Button */}
      <button
        type="button"
        className="close"
        aria-label="Close"
        onClick={toggle}
        style={{
          background: "transparent",
          border: "none",
          fontSize: "2rem",
          cursor: "pointer",
          position: "absolute",
          top: "10px",
          right: "20px",
        }}
      >
        &times;
      </button>

      {/* 🧑 Vendor Profile */}
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ margin: "20px 20px 0 20px", flexDirection: "column" }}
      >
        <Row
          style={{
            width: "100%",
            margin: "8px 6px",
            paddingTop: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Col xs={12} className="text-center">
            <img
              style={{
                borderRadius: "50%",
                height: "180px",
                width: "180px",
                margin: "0 auto",
                display: "block",
              }}
              src={
                vendorData?.Profile_Image?.url ||
                "https://www.shutterstock.com/image-vector/vector-flat-illustration-grayscale-avatar-600nw-2264922221.jpg"
              }
              alt="Vendor Profile"
            />
          </Col>

          <Col xs={12} style={{ paddingTop: "15px" }}>
            <h2
              className="text-center Pheading"
              style={{
                fontWeight: "700",
                color: "#022D88",
              }}
            >
              {vendorData?.Name || "Vendor Name"}
            </h2>
          </Col>
        </Row>
      </div>

      {/* 💳 Payment Buttons */}
      <ModalBody style={{ marginBottom: "20px" }}>
        <h5
          className="text-center"
          style={{ fontWeight: "700", fontSize: "1.25rem", color: "#022D88" }}
        >
          PAY THIS VENDOR
        </h5>

        <h6
          className="text-start"
          style={{
            fontWeight: "400",
            marginTop: "20px",
            padding: "0 1rem",
            color: "#555",
          }}
        >
          Click on your preferred service below in order to pay this vendor. Or
          click view profile to review their details.
        </h6>

        {loading ? (
          <div className="text-center" style={{ marginTop: "20px" }}>
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : (
          <div
            className="d-flex flex-wrap justify-content-center align-items-center"
            style={{
              marginTop: "25px",
              gap: "12px",
              textAlign: "center",
            }}
          >
            {paymentOptions.map((option, index) => {
              const available = isLinkAvailable(option.link);
              return (
                <Button
                  key={index}
                  className="custom-button-Payme d-flex align-items-center justify-content-center"
                  onClick={() => handlePaymentLink(option.link)}
                  disabled={!available}
                  style={{
                    backgroundColor: available ? "#0D6EFC" : "#d3d3d3",
                    border: "none",
                    minWidth: "130px",
                    color: "#fff",
                    fontWeight: "600",
                    padding: "10px 15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={option.img}
                    alt={option.name}
                    style={option.imgStyle}
                    className="me-2"
                  />
                  {option.name}
                  {!available && (
                    <i
                      className="bi bi-lock-fill ms-2"
                      style={{ color: "#555", fontSize: "1rem" }}
                    ></i>
                  )}
                </Button>
              );
            })}

            {/* ❌ Close Button */}
            <Button
              className="custom-button-PaymeClose"
              onClick={toggle}
              style={{
                backgroundColor: "#6c757d",
                border: "none",
                color: "#fff",
                fontWeight: "600",
                padding: "10px 20px",
              }}
            >
              Close
            </Button>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default VendorPayment;
